import type { EventPhoto } from '../../../types';
import type { FieldPolicy } from '@apollo/client';
import type { FieldReadFunction } from '@apollo/client/cache/inmemory/policies';

export default <FieldPolicy<any> | FieldReadFunction<any>>{
  merge: (existing: EventPhoto[] = [], incoming: EventPhoto[] = [], { mergeObjects, isReference, readField }) => {
    const existingMap = existing.reduce((memo, existingPhoto) => {
      const id = isReference(existingPhoto) ? readField('id', existingPhoto) || existingPhoto.__ref : existingPhoto.id;
      memo.set(`${id}`, existingPhoto);
      return memo;
    }, new Map<string, EventPhoto>());
    incoming.forEach((incomingPhoto) => {
      const id = isReference(incomingPhoto) ? readField('id', incomingPhoto) || incomingPhoto.__ref : incomingPhoto.id;
      const newPhoto = mergeObjects<EventPhoto>(existingMap.get(`${id}`) || ({} as EventPhoto), incomingPhoto);
      existingMap.set(`${id}`, newPhoto);
    });
    return [...existingMap.values()];
  },
};
